import {
  RegistrationStatusEnum,
  CategoryValuesEnum,
  DevelopmentPhaseEnum,
  PriorityEnum,
  CredentialsStatusEnum
} from "@services/account/enum/registration.enum";
import { NameValueModel } from "@services/common/model/global.model";

export const REGISTRATION_STATUS_MAP: Record<string, string> = {
  [RegistrationStatusEnum.Deleted]: "Deleted",
  [RegistrationStatusEnum.Pending]: "Pending",
  [RegistrationStatusEnum.UserCreated]: "User Created",
  [RegistrationStatusEnum.Approved]: "Approved",
  [RegistrationStatusEnum.Denied]: "Denied"
};

export const REGISTRATION_STATUS_MAP_ZH: Record<string, string> = {
  [RegistrationStatusEnum.Deleted]: "已删除",
  [RegistrationStatusEnum.Pending]: "待审核",
  [RegistrationStatusEnum.UserCreated]: "用户已创建",
  [RegistrationStatusEnum.Approved]: "已通过",
  [RegistrationStatusEnum.Denied]: "已拒绝"
};

export const REGISTRATION_STATUS_LIST = [
  {
    name: REGISTRATION_STATUS_MAP[RegistrationStatusEnum.Approved],
    value: RegistrationStatusEnum.Approved
  },
  {
    name: REGISTRATION_STATUS_MAP[RegistrationStatusEnum.Pending],
    value: RegistrationStatusEnum.Pending
  },
  {
    name: REGISTRATION_STATUS_MAP[RegistrationStatusEnum.UserCreated],
    value: RegistrationStatusEnum.UserCreated
  },
  {
    name: REGISTRATION_STATUS_MAP[RegistrationStatusEnum.Denied],
    value: RegistrationStatusEnum.Denied
  }
];

export const REGISTRATION_STATUS_LIST_ZH = [
  {
    name: REGISTRATION_STATUS_MAP_ZH[RegistrationStatusEnum.Approved],
    value: RegistrationStatusEnum.Approved
  },
  {
    name: REGISTRATION_STATUS_MAP_ZH[RegistrationStatusEnum.Pending],
    value: RegistrationStatusEnum.Pending
  },
  {
    name: REGISTRATION_STATUS_MAP_ZH[RegistrationStatusEnum.UserCreated],
    value: RegistrationStatusEnum.UserCreated
  },
  {
    name: REGISTRATION_STATUS_MAP_ZH[RegistrationStatusEnum.Denied],
    value: RegistrationStatusEnum.Denied
  }
];

export const CATEGORY_VALUES_MAP: Record<string, string> = {
  [CategoryValuesEnum.SmallMolDevelop]: "Small molecules",
  [CategoryValuesEnum.Antibody]: "Antibody (mAb/sdAb/bsAb/etc)",
  [CategoryValuesEnum.Xdc]: "XDC（ADC/PDC/etc）",
  [CategoryValuesEnum.Peptide]: "Peptide",
  [CategoryValuesEnum.EnzymeOrSyntheticBiology]: "Enzyme/Synthetic Biology",
  [CategoryValuesEnum.Other]: "Others"
};

export const CATEGORY_VALUES_MAP_ZH: Record<string, string> = {
  [CategoryValuesEnum.SmallMolDevelop]: "小分子药物",
  [CategoryValuesEnum.Antibody]: "抗体（mAb/sdAb/bsAb 等）",
  [CategoryValuesEnum.Xdc]: "XDC（ADC/PDC 等）",
  [CategoryValuesEnum.Peptide]: "多肽",
  [CategoryValuesEnum.EnzymeOrSyntheticBiology]: "酶/合成生物学",
  [CategoryValuesEnum.Other]: "其他"
};

export const DEVELOPMENT_PHASE_MAP: Record<string, string> = {
  [DevelopmentPhaseEnum.MolExplore]: "Hit generation (AI-generated hits)",
  [DevelopmentPhaseEnum.MolFilter]:
    "Hit to lead (Property prediction and screening)",
  [DevelopmentPhaseEnum.Optimize]:
    "Lead optimization (Structure modeling, property optimization)",
  [DevelopmentPhaseEnum.Other]: "Others"
};

export const DEVELOPMENT_PHASE_MAP_ZH: Record<string, string> = {
  [DevelopmentPhaseEnum.MolExplore]: "命中发现（AI 生成候选分子）",
  [DevelopmentPhaseEnum.MolFilter]: "命中到先导（性质预测与筛选）",
  [DevelopmentPhaseEnum.Optimize]: "先导优化（结构建模与性质优化）",
  [DevelopmentPhaseEnum.Other]: "其他"
};

export const PRIORITY_MAP: Record<string, string> = {
  [PriorityEnum.WantTryNow]:
    "Yes, I would love to try GeoBiologics in an ongoing project.",
  [PriorityEnum.WantDeeperCommunication]:
    "We’re scoping a project for which GeoBiologics can be useful. Let’s discuss.",
  [PriorityEnum.MayTryLater]:
    "GeoBiologics seems promising and I would love to try it for my project in the future.",
  [PriorityEnum.NotSure]: "I’m unsure if GeoBiologics is relevant to my work."
};

export const PRIORITY_MAP_ZH: Record<string, string> = {
  [PriorityEnum.WantTryNow]:
    "是的，我非常愿意在当前项目中尝试使用 GeoBiologics。",
  [PriorityEnum.WantDeeperCommunication]:
    "我们正在规划一个项目，GeoBiologics 可能会很有帮助，希望进一步沟通。",
  [PriorityEnum.MayTryLater]:
    "GeoBiologics 看起来很有潜力，我希望未来在我的项目中尝试使用。",
  [PriorityEnum.NotSure]: "我还不确定 GeoBiologics 是否适用于我的工作。"
};

export const CATEGORY_VALUES_OPTIONS: NameValueModel[] = [
  {
    name: CATEGORY_VALUES_MAP[CategoryValuesEnum.SmallMolDevelop],
    value: CategoryValuesEnum.SmallMolDevelop
  },
  {
    name: CATEGORY_VALUES_MAP[CategoryValuesEnum.Antibody],
    value: CategoryValuesEnum.Antibody
  },
  {
    name: CATEGORY_VALUES_MAP[CategoryValuesEnum.Xdc],
    value: CategoryValuesEnum.Xdc
  },
  {
    name: CATEGORY_VALUES_MAP[CategoryValuesEnum.Peptide],
    value: CategoryValuesEnum.Peptide
  },
  {
    name: CATEGORY_VALUES_MAP[CategoryValuesEnum.EnzymeOrSyntheticBiology],
    value: CategoryValuesEnum.EnzymeOrSyntheticBiology
  },
  {
    name: CATEGORY_VALUES_MAP[CategoryValuesEnum.Other],
    value: CategoryValuesEnum.Other
  }
];

export const CATEGORY_VALUES_OPTIONS_ZH: NameValueModel[] = [
  {
    name: CATEGORY_VALUES_MAP_ZH[CategoryValuesEnum.SmallMolDevelop],
    value: CategoryValuesEnum.SmallMolDevelop
  },
  {
    name: CATEGORY_VALUES_MAP_ZH[CategoryValuesEnum.Antibody],
    value: CategoryValuesEnum.Antibody
  },
  {
    name: CATEGORY_VALUES_MAP_ZH[CategoryValuesEnum.Xdc],
    value: CategoryValuesEnum.Xdc
  },
  {
    name: CATEGORY_VALUES_MAP_ZH[CategoryValuesEnum.Peptide],
    value: CategoryValuesEnum.Peptide
  },
  {
    name: CATEGORY_VALUES_MAP_ZH[CategoryValuesEnum.EnzymeOrSyntheticBiology],
    value: CategoryValuesEnum.EnzymeOrSyntheticBiology
  },
  {
    name: CATEGORY_VALUES_MAP_ZH[CategoryValuesEnum.Other],
    value: CategoryValuesEnum.Other
  }
];

export const DEVELOPMENT_PHASE_OPTIONS: NameValueModel[] = [
  {
    name: DEVELOPMENT_PHASE_MAP[DevelopmentPhaseEnum.MolExplore],
    value: DevelopmentPhaseEnum.MolExplore
  },
  {
    name: DEVELOPMENT_PHASE_MAP[DevelopmentPhaseEnum.MolFilter],
    value: DevelopmentPhaseEnum.MolFilter
  },
  {
    name: DEVELOPMENT_PHASE_MAP[DevelopmentPhaseEnum.Optimize],
    value: DevelopmentPhaseEnum.Optimize
  },
  {
    name: DEVELOPMENT_PHASE_MAP[DevelopmentPhaseEnum.Other],
    value: DevelopmentPhaseEnum.Other
  }
];

export const DEVELOPMENT_PHASE_OPTIONS_ZH: NameValueModel[] = [
  {
    name: DEVELOPMENT_PHASE_MAP_ZH[DevelopmentPhaseEnum.MolExplore],
    value: DevelopmentPhaseEnum.MolExplore
  },
  {
    name: DEVELOPMENT_PHASE_MAP_ZH[DevelopmentPhaseEnum.MolFilter],
    value: DevelopmentPhaseEnum.MolFilter
  },
  {
    name: DEVELOPMENT_PHASE_MAP_ZH[DevelopmentPhaseEnum.Optimize],
    value: DevelopmentPhaseEnum.Optimize
  },
  {
    name: DEVELOPMENT_PHASE_MAP_ZH[DevelopmentPhaseEnum.Other],
    value: DevelopmentPhaseEnum.Other
  }
];

export const PRIORITY_OPTIONS: NameValueModel[] = [
  {
    name: PRIORITY_MAP[PriorityEnum.WantTryNow],
    value: PriorityEnum.WantTryNow
  },
  {
    name: PRIORITY_MAP[PriorityEnum.WantDeeperCommunication],
    value: PriorityEnum.WantDeeperCommunication
  },
  {
    name: PRIORITY_MAP[PriorityEnum.MayTryLater],
    value: PriorityEnum.MayTryLater
  },
  {
    name: PRIORITY_MAP[PriorityEnum.NotSure],
    value: PriorityEnum.NotSure
  }
];

export const PRIORITY_OPTIONS_ZH: NameValueModel[] = [
  {
    name: PRIORITY_MAP_ZH[PriorityEnum.WantTryNow],
    value: PriorityEnum.WantTryNow
  },
  {
    name: PRIORITY_MAP_ZH[PriorityEnum.WantDeeperCommunication],
    value: PriorityEnum.WantDeeperCommunication
  },
  {
    name: PRIORITY_MAP_ZH[PriorityEnum.MayTryLater],
    value: PriorityEnum.MayTryLater
  },
  {
    name: PRIORITY_MAP_ZH[PriorityEnum.NotSure],
    value: PriorityEnum.NotSure
  }
];

export const REGISTRATION_STATUS_COLOR = {
  [RegistrationStatusEnum.Approved]: "approved",
  [RegistrationStatusEnum.Deleted]: "",
  [RegistrationStatusEnum.Denied]: "denied",
  [RegistrationStatusEnum.Pending]: "pending",
  [RegistrationStatusEnum.UserCreated]: "created"
};

export const CREDENTIAL_STATUS_LABEL = {
  [CredentialsStatusEnum.Active]: "Active",
  [CredentialsStatusEnum.Disabled]: "Disabled",
  [CredentialsStatusEnum.Delete]: "Deleted"
};

export const CREDENTIAL_STATUS_LABEL_EN = {
  [CredentialsStatusEnum.Active]: "active",
  [CredentialsStatusEnum.Disabled]: "disable",
  [CredentialsStatusEnum.Delete]: "delete"
};

export const CREDENTIAL_STATUS_LABEL_CN = {
  [CredentialsStatusEnum.Active]: "启用",
  [CredentialsStatusEnum.Disabled]: "禁用",
  [CredentialsStatusEnum.Delete]: "删除"
};
